/* RESPONSIBLE TEAM: team-inbox-experience */
import TeamSummary, { UNASSIGNED_ID } from 'embercom/objects/inbox/team-summary';

const UnassignedTeamSummary = TeamSummary.deserialize({
  id: UNASSIGNED_ID,
  name: '',
});

export default UnassignedTeamSummary;
